import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { ButtonGroup, Grid, Button, FormControlLabel, Checkbox, Chip } from '@material-ui/core';
import moment from 'moment';
import { EVENT_DAYS, CHANNEL_DP, PROGRAM_URL, EVENT_ID, EVENT_IMG, EVENTS_API_URL } from '../constatns';
import { pgmDetail } from '../constatns/pgmDetail';
import axios from 'axios';
import ProgramScientificSearchBar from './ProgramScientificSearchBar';

const styles = (theme) => ({
  root: {
    height: '100%',
    // background: `url('images/kcr_poster_category.png') no-repeat`,
    // backgroundSize: 'cover',
    position: 'relative',
    // backgroundImage: `url('/images/kcr_poster_category.png')`,\
    backgroundPosition: 'center',
    backgroundSize: '100%',
    backgroundRepeat: 'no-repeat',
    // marginTop: '-90px',
  },
  searchDiv: {
    padding: '25px 80px',
    backgroundColor: '#f3f3f3',
    display: 'flex',
    justifyContent: 'space-between',
    justifyContentItems: 'center',
  },
  searchBox: {
    width: '69%',
    backgroundColor: '#ffffff',
    '& .MuiOutlinedInput-adornedEnd': {
      paddingRight: '0',
    },
  },
  formControl: {
    width: '15%',
  },
  InputAdornment: {
    display: 'block',
    height: '100%',
    maxHeight: '100%',
    margin: 0,
  },
  roomButton: {
    margin: '8px',
    borderRadius: '7px !important',
  },
  selectViewBox: {
    border: '1px solid #ccc',
    textAlign: 'center',
  },
  selectViewTitle: {
    width: '100%',
    backgroundColor: '#273e82',
    color: '#fff',
    padding: '15px 0 16px',
    // textAlign: 'center',
    fontSize: '16px',
  },
  selectViewContents: {
    padding: '40px 50px',
    textAlign: 'left',
  },
  pgmTitle: {
    color: '#fff',
    width: '100%',
    fontSize: '16px',
    // backgroundColor: '#511b71',
    backgroundColor: '#237a9d',
    marginTop: '30px',
    minHeight: '77px',
    '& > div': {
      padding: '15px',
      alignItems: 'center',
      fontSize: '1.1rem',
    },
  },
  pgmTitleDetail: {
    fontSize: '16px',
    padding: '17px',
    fontWeight: 'bold',
    borderBottom: '1px solid #273e82',
  },
  scheduleTitle: {
    justifyContent: 'center',
    justifyContentItems: 'center',
    alignItems: 'center',
    padding: '15px',
    backgroundColor: '#f4f5f9',
    fontWeight: 'bold',
  },
  scheduleContents: {
    justifyContentItems: 'center',
    justifyContent: 'flex-start',
    alignItems: 'center',
    padding: '15px',

    '& > p': {
      width: '100%',
    },
  },
  scheduleContentsMobile: {
    justifyContentItems: 'center',
    justifyContent: 'flex-start',
    alignItems: 'center',
    padding: '15px',

    '& > p': {
      width: '100%',
      fontSize: '10px',
      lineHeight: '11px',
    },
  },
  chip: {
    background: '#930E11',
    color: '#fff',
    marginLeft: '5px',
    fontSize: '15px',
    height: '24px',
  },
  noData: {
    height: '150px',
    fontSize: '1rem',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
});

const StyledTitleGrid = withStyles((theme) => ({
  root: {
    padding: '20px',
    fontSize: 18,
    // minHeight: 92,
  },
}))(Grid);

const StyledGrid = withStyles(() => ({
  root: {
    padding: '15px 20px',
    fontSize: 16,
    border: '1px solid #efefef',
    alignItems: 'center',
    // minHeight: 91,
  },
}))(Grid);

class ProgramScientific extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectDate: 'all',
      selectRoom: 0,
      searchData: '',
      choice: [],
      arrDate: EVENT_DAYS,
      data: [],
      idx: 0,
    };
  }

  componentDidMount() {
    this.getData();
    // const eventDays = getEventDays();
    // this.setState({ arrDate: eventDays._buffs });
  }

  roomChange(idx) {
    this.setState({ selectRoom: idx });
  }

  selectChoice = (e) => {
    const value = e.target.value;
    let _choice = this.state.choice;

    if (_choice.indexOf(value) > -1) {
      _choice = _choice.filter((item) => {
        return item !== value;
      });
    } else {
      _choice.push(value);
    }

    this.setState({ choice: _choice });
  };

  search = (searchDate, searchInput) => {
    this.getNumber(searchDate);

    this.setState({ searchData: searchInput.toLowerCase() });
  };

  clearSearch = () => {
    this.setState({ selectDate: 'all', selectRoom: 0, choice: [], searchData: '' });
  };

  getNumber(idx) {
    let _date = idx;
    let item = JSON.parse(sessionStorage.getItem('EVENT'));

    if (item) {
      if (this.state.arrDate[idx]) {
        _date = moment(this.state.arrDate[idx]).format('YYYYMMDD');
      }
    }

    this.setState({ selectDate: _date });
  }

  getData = () => {
    axios.get(`${PROGRAM_URL}/program/detailAll?eventId=evt120`, { headers: { Pragma: 'no-cache' } }).then((response) => {
      // let res = response.data;

      let res = response.data.sort((a, b) => {
        return (
          // Number(a.resNum) - Number(b.resNum)

          // * 세부 프로그램 안에 세부항목 sortOrder 가 없기 때문에 구분 가능한 행사일, 방번호, 시작시간, 세부항목 순서를 상위항목이 한자리씩 더 큰 수가 되게 만들어 더해서 order가 되는 숫자를 크게 만듬
          Number(
            Number(a.pgmInfo.pgDate) +
              Number(a.pgmInfo.channel.replace('Room', '')) * 0.1 +
              Number(a.pgmInfo.startTime.replace(':', '')) * 0.0001 +
              Number(a.order) * 0.00001, // ALL 을 표기하기 위한 order가 99인 관계로 좀더 작은 수로 만들기
          ) -
          Number(
            Number(b.pgmInfo.pgDate) +
              Number(b.pgmInfo.channel.replace('Room', '')) * 0.1 +
              Number(b.pgmInfo.startTime.replace(':', '')) * 0.0001 +
              Number(b.order) * 0.00001,
          )
        );
      });

      this.setState({ data: res });
      // console.log(this.state.data, 'data');
    });
  };

  dataFilter = (data) => {
    const { selectDate, selectRoom, choice, searchData } = this.state;
    let _data = data;

    // console.log(_data, 'data');

    let select = null;
    let room = `Room${selectRoom}`;

    if (selectRoom === 0) room = 'Room';
    if (selectDate === 'all') select = 'day';
    else if (selectDate === moment(this.state.arrDate[0]).format('YYYYMMDD')) select = 'day1';
    else if (selectDate === moment(this.state.arrDate[1]).format('YYYYMMDD')) select = 'day2';
    else if (selectDate === moment(this.state.arrDate[2]).format('YYYYMMDD')) select = 'day3';

    //  day
    _data = data.filter((data) => {
      return data.day.indexOf(select) > -1;
    });

    // channel
    // _data = _data.filter((_data) => {
    //   return _data.channel.indexOf(room) > -1;
    // });

    _data = _data.filter((_data) => {
      return _data.pgmInfo.channel.indexOf(room) > -1;
    });

    // select choice
    if (choice.length > 0) {
      let check = new Set();
      let _choice = [...choice];

      _data.map((item) => {
        let name = item.pgmInfo.pgTitle;
        // if (Number(item.pgmInfo.pgTitle.replace(/[^0-9]/g, '')) > 0) {
        //   name = item.pgmInfo.pgTitle.slice(0, item.pgmInfo.pgTitle.lastIndexOf(' '));
        // }
        for (let i = 0; i < _choice.length; i++) {
          if (name.includes(_choice[i])) {
            check.add(item.pgmId);
          }
        }
      });

      // if (choice.indexOf('Keynote Lecture') > -1) {
      //   check.add('evt029_pg114');
      //   check.add('evt029_pg025');
      //   check.add('evt029_pg085');
      // }
      _data = _data.filter((_data) => {
        return Array.from(check).includes(_data.pgmId);
      });
    }

    // 검색
    if (searchData) {
      let check = new Set();

      _data.map((item) => {
        if (
          item.pgmInfo.pgTitle.toLowerCase().includes(searchData) ||
          item.pgmInfo.pgSub.toLowerCase().includes(searchData) ||
          item.presenter.toLowerCase().includes(searchData) ||
          // item.affiliation.toLowerCase().includes(searchData) ||
          item.contents.toLowerCase().includes(searchData)
        ) {
          check.add(item.pgmId);
        }
      });

      _data = _data.filter((_data) => {
        return Array.from(check).includes(_data.pgmId);
      });
      // Array.from(check).map((item) => {
      // });
    }

    return _data;
  };

  renderDetailData = (data) => {
    const { classes } = this.props;

    // 필터
    data = this.dataFilter(data);

    // console.log(data, 'data');
    if (data.length > 0) {
      return data.map((item, idx) => {
        const day = this.state.arrDate[parseInt(item.day && item.day.split('day')[1]) - 1];
        const room = item.channel;
        const color =
          item.pgmInfo.channel === 'Room1'
            ? 'rgba(144,150,26)'
            : item.pgmInfo.channel === 'Room2'
            ? 'rgba(63,125,79)'
            : item.pgmInfo.channel === 'Room3'
            ? 'rgba(24,90,106)'
            : item.pgmInfo.channel === 'Room4'
            ? 'rgba(44,74,106)'
            : 'rgba(80,43,107)';

        const titleColor =
          item.pgmInfo.channel === 'Room1'
            ? 'rgba(217,225,87)'
            : item.pgmInfo.channel === 'Room2'
            ? 'rgba(136,195,151)'
            : item.pgmInfo.channel === 'Room3'
            ? 'rgba(106,198,220)'
            : item.pgmInfo.channel === 'Room4'
            ? 'rgba(152,181,212)'
            : 'rgba(186,151,213)';

        return (
          <React.Fragment key={`${item.pgmInfo.pgTitle}_title${idx}`}>
            {item.order == 0 && (
              <Grid container style={{ paddingTop: '4vh' }}>
                <Grid container item xs={12}>
                  {/* <StyledTitleGrid container alignItems="center" item xs={10} style={{ backgroundColor: color.replace(')', ',0.5)') }}> */}
                  <StyledTitleGrid container alignItems="center" item xs={10} style={{ backgroundColor: titleColor }}>
                    <div style={{ fontWeight: 'bold' }}>
                      {item.pgmInfo.pgTitle}
                      {item.pgmInfo.pgSub !== '' ? <b>. &nbsp;</b> : ''}
                    </div>
                    <div>
                      {item.pgmInfo.pgSub}
                      {item.pgmInfo.pgTitle.includes('(KOR)') ? <Chip className={classes.chip} label={'KOR'} /> : ''}
                    </div>
                    {item.pgmInfo.logo && (
                      <div style={{ display: 'flex', height: '100%', alignItems: 'center' }}>
                        <img src={`${EVENT_IMG}/ic/logo${item.pgmInfo.logo}.png`} alt="" style={{ marginLeft: 16, height: 30 }} />
                      </div>
                    )}
                  </StyledTitleGrid>
                  <StyledTitleGrid
                    container
                    alignItems="center"
                    justifyContent="center"
                    item
                    xs={2}
                    style={{ backgroundColor: color, color: '#fff', fontWeight: 'bold' }}
                  >
                    {`${item.pgmInfo.channel.replace('Room', 'Room ')}`}
                  </StyledTitleGrid>
                </Grid>
                <Grid container item xs={12}>
                  <StyledGrid container alignItems="center" item xs={2} justifyContent="center">
                    <b>Date & Time</b>
                  </StyledGrid>
                  <StyledGrid container alignItems="center" item xs={10} style={{ paddingLeft: 40 }}>
                    {`${moment(day).format('MMM. DD (ddd)')} ${item.pgmInfo.startTime} ~ ${item.pgmInfo.endTime}`}
                  </StyledGrid>
                </Grid>
              </Grid>
            )}

            <Grid container item xs={12}>
              {/* <Grid>
                {Number(
                  Number(item.pgmInfo.pgDate) +
                    Number(item.pgmInfo.channel.replace('Room', '')) * 0.1 +
                    Number(item.pgmInfo.startTime.replace(':', '')) * 0.0001 +
                    Number(item.order) * 0.00001,
                )}
              </Grid> */}

              {item.order == 0 ? (
                <>
                  <StyledGrid item xs={2} container alignItems="center" justifyContent="center">
                    <b>Moderator(s)</b>
                  </StyledGrid>
                  <StyledGrid item xs={10} container alignItems="center" style={{ paddingLeft: 45 }}>
                    <div
                      style={{ fontWeight: 'bold' }}
                      dangerouslySetInnerHTML={{
                        __html: item.contents.replace('),', ')<br/>').replace('TBD,', 'TBD<br/>'),
                      }}
                    />
                    <div>{item.presenter}</div>
                  </StyledGrid>
                </>
              ) : (
                <>
                  <StyledGrid item xs={2} container alignItems="center" justifyContent="center">
                    <b>
                      {
                        // item.order == 0 ? 'Moderator(s)' :
                        item.order == 99 ? 'All' : 'Speaker'
                      }
                    </b>
                  </StyledGrid>
                  <StyledGrid item xs={2} container alignItems="center" justifyContent="center">
                    <div>{item.title}</div>
                  </StyledGrid>
                  <StyledGrid item xs={8} container alignItems="center" style={{ paddingLeft: 20 }}>
                    {item.order == 0 ? (
                      <div
                        style={{ fontWeight: 'bold' }}
                        dangerouslySetInnerHTML={{
                          __html: item.contents.replace('),', ')<br/>').replace('TBD,', '),TBD<br/>'),
                        }}
                      />
                    ) : (
                      <div style={{ fontWeight: 'bold' }}>{item.contents}</div>
                    )}
                    <Grid item xs={12} style={{ fontStyle: 'italic' }}>
                      {item.presenter}
                    </Grid>
                  </StyledGrid>
                </>
              )}
            </Grid>
          </React.Fragment>
        );
      });
    } else {
      return (
        <div className={classes.noData}>
          <p>조건에 맞는 데이터가 없습니다.</p>
        </div>
      );
    }
  };

  getDateButton = () => {
    return this.state.arrDate.map((data, idx) => {
      const val = moment(data).format('YYYYMMDD');

      return (
        <Button
          key={`${data}_Date${idx}`}
          className={this.props.classes.dateButton}
          onClick={() => {
            this.getNumber(idx);
          }}
          variant={this.state.selectDate === val ? 'contained' : 'outlined'}
        >
          {`Day ${idx + 1}`} <br />
          {moment(data).format('MMM. DD (ddd)')}
        </Button>
      );
    });
  };

  getRoomButton = () => {
    const { classes } = this.props;

    return CHANNEL_DP.map((data, idx) => {
      const val = parseInt(data.split(' ')[1]);
      // console.log(data, 'data');
      return (
        <Button
          key={`${data}_Channel${idx}`}
          className={classes.roomButton}
          size="large"
          color="secondary"
          onClick={() => {
            this.roomChange(idx + 1);
          }}
          style={{ color: this.state.selectRoom === val ? '#fff' : '#aacb3c', display: data === 'Faculty Room' ? 'none' : 'flex' }}
          variant={this.state.selectRoom === val ? 'contained' : 'outlined'}
        >
          {data}
        </Button>
      );
    });
  };

  render() {
    const { classes } = this.props;
    const { arrDate, selectDate, selectRoom, data } = this.state;

    return (
      <Grid container>
        <ProgramScientificSearchBar arrDate={arrDate} search={this.search} clearSearch={this.clearSearch} />

        <Grid item xs={12} style={{ marginTop: '30px' }}>
          {arrDate && arrDate.length > 0 ? (
            <ButtonGroup color="primary" disableElevation aria-label="outlined primary button group" fullWidth style={{ height: '78px' }}>
              <Button
                className={classes.dateButton}
                onClick={() => {
                  this.getNumber('all');
                }}
                variant={selectDate === 'all' ? 'contained' : 'outlined'}
              >
                All Day <br />
                {`${moment(arrDate[0]).format('MMM. DD (ddd)')} ~ ${moment(arrDate[2]).format('DD (ddd)')}`}
              </Button>
              {this.getDateButton()}
            </ButtonGroup>
          ) : null}
        </Grid>
        <Grid item xs={12} style={{ marginTop: '30px' }}>
          <div style={{ display: 'flex', width: '100%', justifyContent: 'center' }}>
            <Button
              className={classes.roomButton}
              size="large"
              color="secondary"
              onClick={() => {
                this.roomChange(0);
              }}
              style={{ color: selectRoom === 0 ? '#fff' : '#aacb3c' }}
              variant={selectRoom === 0 ? 'contained' : 'outlined'}
            >
              All Room
            </Button>
            {this.getRoomButton()}
          </div>
        </Grid>
        <Grid item xs={12} style={{ marginTop: '30px' }}>
          <div className={classes.selectViewBox}>
            <div className={classes.selectViewTitle}>SELECT AND VIEW SESSIONS OF YOUR CHOICE!</div>
            <div className={classes.selectViewContents}>
              {pgmDetail.map((item, idx) => (
                <FormControlLabel
                  key={`${item.value}_form_${idx}`}
                  style={{ margin: '3px' }}
                  value={item.value}
                  control={
                    <Checkbox
                      size="small"
                      onClick={(e) => this.selectChoice(e)}
                      checked={this.state.choice.includes(item.value) ? true : false}
                    />
                  }
                  label={item.value.replace('Lecture', 'Keynote Lecture').replace('Fat and Stem Cells', 'Asian Fat and Stem Cells Forum')}
                />
              ))}
            </div>
          </div>
        </Grid>
        <Grid item xs={12} style={{ marginTop: '15px', textAlign: 'right' }}>
          <p style={{ fontWeight: 'bold' }}>
            <Chip className={classes.chip} label={'KOR'} /> Korean Lecture
          </p>
        </Grid>
        <Grid item xs={12}>
          {data.length > 0 && this.renderDetailData(data)}
        </Grid>
      </Grid>
    );
  }
}

export default withStyles(styles)(ProgramScientific);
